<template>
    <v-row class="justify-center" no-gutters>
        <v-col cols="12" xs="12" sm="12" md="12" lg="10" xl="10" class="text-left pa-2">
            <v-row class="justify-left">
                <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8" class="align-center text-left ">
                    <!-- // * VENUES / ADD VENUE -->
                    <div class="d-flex align-center">
                        <div class="pb-1 heading4 secondary--text">Venues</div>
                        <v-spacer />
                        <v-btn class="secondary" @click="formAction('Add', '')">Add Venue</v-btn>
                    </div>
                    <!-- // * EVENT SEARCH / FILTERES -->
                    <v-row no-gutters class="pa-0 mb-4">
                        <v-col class="pr-1" cols="12" xs="" sm="" md="" lg="" xl=""><v-text-field clearable v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details dark filled background="white"  ></v-text-field></v-col>
                    </v-row>                
            
                <v-card>
                <v-data-table
                  :headers="computedHeaders"
                  :items="venues"
                  :items-per-page="20"
                  class="elevation-1"
                  :search="search"
                  :mobile-breakpoint="0"
                >
                <template v-slot:[`item.actions`]="{ item }">
                    <div class="d-flex justify-end">
                        <div style="width: 50px !important;" ><v-icon small @click="formAction('Edit', item)" class="icons8-edit mr-2"></v-icon>
                            <v-icon small @click="deleteVenue(item.id, item.venueName)" class="icons8-trash"></v-icon>
                        </div>
                    </div>
                </template>
                <template v-slot:[`item.createdDatetime`]="{ item }">
                    {{ $moment(item.createdDatetime, 'x').format('DD MMM YY | HH:mm:ss') }}
                </template>
                <template v-slot:[`item.updatedDatetime`]="{ item }">
                    {{ $moment(item.updatedDatetime, 'x').format('DD MMM YY | HH:mm:ss') }}
                </template>
                <template v-slot:[`item.createdUserId`]="{ item }">
                    {{ lookupUser(item.createdUserId, 'fullName') }}
                </template>
                <template v-slot:[`item.updatedUserId`]="{ item }">
                    {{ lookupUser(item.updatedUserId, 'fullName') }}
                </template>                
                
                </v-data-table>
                   </v-card>
            </v-col>
            <transition
                name="custom-classes-transition"
                enter-active-class="animate__animated animate__fadeIn"
                leave-active-class="animate__animated animate__fadeOut"
                mode="out-in"
            >

            <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="text-left" v-if="showForm">
                <div class="darkgrey card  pa-4">
                <div class="heading6">{{ formType }} Venue</div>
                <v-row align="center">
                    <v-col cols="12" class="text-left">
                        <v-form ref="venues" v-model="valid" lazy-validation>
                        <v-text-field hide-details="auto" :rules="[(v) => !!v || 'Add a name for the venue.']" required class="mb-3" label="Name" v-model="venueForm.venueName" dark filled background="white" ></v-text-field>
                   
                        <v-text-field hide-details="auto" :rules="[(v) => !!v || 'Add an address for the venue.']" required label="Address" v-model="venueForm.venueAddress" dark filled background="white" ></v-text-field>
                   </v-form>
                    </v-col>
                    <v-col cols="12" class="d-flex align-center justify-end">
                        <div class="mr-2">
                            <v-btn depressed @click="showForm = false" class="grey">Close</v-btn>
                        </div>
                        <v-spacer />
                        <div class="mr-2">
                            <v-btn depressed v-if="formType === 'Edit'"  @click="deleteVenue(venueForm.id, venueForm.venueName)" color="white"><span class="black--text">Delete Venue</span></v-btn>
                        </div>
                        <div>
                            <v-btn depressed v-if="formType === 'Add'" @click="createVenue()" color="secondary">Save Venue</v-btn>
                            <v-btn depressed v-if="formType === 'Edit'" @click="updateVenue()" color="secondary">Update</v-btn>
                        </div>
                    </v-col>
                </v-row>
                </div>
            </v-col>
            </transition>
        </v-row>
        <!-- <pre align="left">{{ venueFormDefault }}</pre> -->
        <transition
            name="custom-classes-transition"
            enter-active-class="animate__animated animate__fadeIn"
            leave-active-class="animate__animated animate__fadeOut"
            mode="out-in"
        >
        <appsnackbar :status="snackbar.status" :color="snackbar.color" :timeout="snackbar.timeout" :message="snackbar.message" :key="snackbarKey" />
        </transition>
    </v-col>

      <v-dialog style="z-index: 3000 !important;"
      v-model="deleteDialog"
      persistent
      max-width="300">
      <v-card>
        <v-card-title  class="background white--text">
         Delete Venue
        </v-card-title>
        <v-card-text class="mt-6"> <p class="subtitle1">Are you sure you want to delete the venue <strong>{{deleteName}}</strong>?</p></v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="lightgrey" @click="noAction()"> No</v-btn>
          <v-btn class="secondary" @click="yesAction()">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</v-row>
</template>

<script>

// Clases
class SNACKBAR {
    constructor(status, color, message, timeout) {
        this.status = status;
        this.color = color;
        this.message = message;
        this.timeout = timeout;
    }
}

class VENUEFORM {
    constructor(id, venueName, venueAddress, createdUserId, createdDatetime, updatedUserId, updatedDatetime) {
        this.id = id;
        this.venueName = venueName;
        this.venueAddress = venueAddress;
        this.createdUserId = createdUserId;
        this.createdDatetime = createdDatetime;
        this.updatedUserId = updatedUserId;
        this.updatedDatetime = updatedDatetime;
    }
}

export default {
    data(){
        return {
            search: '',
             deleteDialog: false,
            deleteName: '',
            deleteId: '',
            snackbarKey: 0,
            snackbar: {},
            showForm: false,
            formType: '', 
            venueForm: {},
            headers: [
                { text: 'ID', value: 'id', align: 'start', sortable: true, hidden: true },
                { text: 'Name', value: 'venueName', align: 'start', sortable: true, hidden: false },
                { text: 'Address', value: 'venueAddress', align: 'start', sortable: true, hidden: false },
                { text: 'Created By', value: 'createdUserId', align: 'start', sortable: true, hidden: true },
                { text: 'Created Date', value: 'createdDatetime', align: 'start', sortable: true, hidden: true },
                { text: 'Updated By', value: 'updatedUserId', align: 'start', sortable: true, hidden: true },
                { text: 'Updated Date', value: 'updatedDatetime', align: 'start', sortable: true, hidden: true },
                { text: 'Action', value: 'actions', align: 'end', hidden: false },
            ],
            venues: [],
            valid: true
        }
    },
    methods: {
        formAction(action, item) {
            this.formType = action;
            if (action === 'Add') {
                this.venueForm = new VENUEFORM(null,'','', null, null, null, null); // clear venue form
            } else {
                this.venueForm = new VENUEFORM(item.id, item.venueName, item.venueAddress, item.createdUserId, item.createdDatetime, item.updatedUserId, item.updatedDatetime);
            }
            this.showForm = true; // show form
            this.$nextTick(() => {
                if (this.$vuetify.breakpoint.name === 'xs') {
                    this.$vuetify.goTo(700)
                }
            });
        },
        async createVenue() {
            if (this.$refs.venues.validate()) {
                delete this.venueForm.id; // remove the id as we are creating a new venue
                var result = await this.createDocument('venues', this.venueForm) // add menu through mixins
                if (result.code === 1) {
                    this.snackbar = new SNACKBAR(true,'success','Venue Added',2000); // update snack bar with success
                    this.snackbarKey++
                    this.venueForm = new VENUEFORM(null,'','', null, null, null, null); // clear venue form
                    this.showForm = false;
                } else {
                    this.snackbar = new SNACKBAR(true,'errorSnackbar','Error Adding Venue',3000); // update snack bar with error
                    this.snackbarKey++
                }
            } else{
                this.snackbar = new SNACKBAR(true,'errorSnackbar','Fill in every field in order to proceed.',3000); // update snack bar with error
                this.snackbarKey++;
            }
        },
        async updateVenue() {
            if (this.$refs.venues.validate()) {
                var result = await this.updateDocument('venues', this.venueForm); // update venue through mixins
                if (result.code === 1) { // if update venue was successful
                    this.snackbar = new SNACKBAR(true,'success','Venue Updated',2000); // update snack bar with success
                    this.snackbarKey++ // update snack bar component key to clear component
                    this.venueForm = new VENUEFORM(null,'','', null, null, null, null); // clear venue form
                    this.showForm = false; // hide form
                } else {
                    this.snackbar = new SNACKBAR(true,'errorSnackbar','Error Updating Venue',3000); // update snack bar with error
                    this.snackbarKey++ // update snack bar component key to clear component
                }
            } else{
                this.snackbar = new SNACKBAR(true,'errorSnackbar','Fill in every field in order to proceed.',3000); // update snack bar with error
                this.snackbarKey++;
            }
        }, 
         deleteVenue(id, name) {
            this.deleteDialog = true;
            this.deleteName = name;
            this.deleteId = id;
        },       
        async yesAction() {
            var result = await this.deleteDocument('venues', this.deleteId); // delete venue through mixins
            if (result.code === 1) {
                this.deleteDialog = false;
                this.showForm = false;
                this.snackbar = new SNACKBAR(true,'success','Venue Deleted',1000); // update snack bar with success
                this.snackbarKey++ // update snack bar component key to clear component
            } else {
                this.deleteDialog = false;
                this.showForm = false;
                this.snackbar = new SNACKBAR(true,'errorSnackbar','Error Deleting Venue',3000); // update snack bar with error
                this.snackbarKey++ // update snack bar component key to clear component
            }
        },
         noAction(){
            this.deleteDialog = false;
            this.deleteName = '';
            this.deleteId = '';
        }
    },
    create() {
        // on create set default data objects
        this.venueForm = new VENUEFORM(null,'','',null,null,null,null); // set default
        this.snackbar = new SNACKBAR(false,'black','',3000); // set default
    },
    async mounted() { 
        this.readDocuments('users', 'users'); // get list of questions from database
        this.readDocuments('venues', 'venues'); // get list of venues from database
    }
}
</script>